<div class="header">
  <div class="container">
    <a routerLink="/" class="flex"><img src="/assets/logo.svg" alt="" /></a>
    <div class="menu-container">
      <p-menubar [model]="items()" class="menu"></p-menubar>
    </div>
    <div>
      <p-menubar [model]="profileItems()"></p-menubar>
    </div>
  </div>
</div>
